import { useSearchParams } from 'react-router-dom';
import { useGetWriteoffWorklistQuery } from '../../../../../../services/WriteoffService';
import { WriteoffWorklistType, WRITEOFF_WORKLIST_TYPES } from '../../../../../../services/WriteoffService/types/writeoffWorklistTypes';

export interface UseWorklistDataReturn {
  worklistItems: any[];
  isLoading: boolean;
  error: any;
  refetch: () => void;
  company: string;
  center: string;
  type: WriteoffWorklistType;
}

/**
 * Hook for fetching worklist data based on URL params.
 */
export function useWorklistData(): UseWorklistDataReturn {
  const [searchParams] = useSearchParams();

  const company = searchParams.get('company') || '';
  const center = searchParams.get('center') || '';
  const typeParam = searchParams.get('type') || '';

  // Validate type parameter
  const type: WriteoffWorklistType = WRITEOFF_WORKLIST_TYPES.includes(typeParam as WriteoffWorklistType)
    ? (typeParam as WriteoffWorklistType)
    : 'Draft';

  const {
    data: worklistItems = [],
    isLoading,
    error,
    refetch,
  } = useGetWriteoffWorklistQuery(
    { type, center, company },
    { skip: !type || !center || !company }
  );

  return {
    worklistItems,
    isLoading,
    error,
    refetch,
    company,
    center,
    type,
  };
}
